import moment from 'moment';

type Props = {
  /** the start time as unix timestamp (ms) */
  start: timestamp;
  /** the end time as unix timestamp (ms) */
  end: timestamp;
  className?: string;
};

/**
 * Renders an humanized time duration.
 * Example: a few seconds, a minute, etc.
 */
export const FormattedTimeDuration: React.FC<Props> = ({ start, end, className }) => {
  return <span className={className}>{moment.duration(end - start).humanize()}</span>;
};
